import { routeNames } from '@/router/names.ts'

export const RODO_DOCUMENT = 'rodo_required'
export const CHILD_PROTECT_DOCUMENT = 'child_protect_required'

export const routeNamesByDocumentCode = {
    [RODO_DOCUMENT]: routeNames.RODO_GUARDIAN_VIEW_NAME,
    [CHILD_PROTECT_DOCUMENT]: routeNames.CHILD_PROTECTION_VIEW_NAME,
}
